import React from "react";
import styles from "./DeeplinkRegisterHeader.module.css";
import { reconstructEventString } from "../../utils/eventString.utils";

const DeeplinkRegisterHeader = ({ deeplinkParams, schoolDetails }) => {
  const { event, level, round } = deeplinkParams || {};
  const { school_name, city } = schoolDetails || {};

  const eventDisplayName = reconstructEventString({ event, level, round });

  const formatName = (str) =>
    str
      ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      : "";

  const schoolDisplayName = school_name
    ? city
      ? `${formatName(school_name)}, ${formatName(city)}`
      : formatName(school_name)
    : null;

  return (
    <div className={styles.deeplinkRegisterHeader}>
      <div className={styles.welcomeText}>
        <p className={styles.welcomeTitle}>Welcome to Genius Club</p>
        {eventDisplayName && (
          <>
            <p className={styles.registrationLabel}>Registration for</p>
            <p className={styles.eventName}>{eventDisplayName}</p>
          </>
        )}
        {schoolDisplayName && <p className={styles.schoolName}>{schoolDisplayName}</p>}
      </div>
    </div>
  );
};

export default DeeplinkRegisterHeader;
